import BibliographyDetailCollectionTable, {
  BibliographyDetailCollectionTableItem,
  defaultBibliographyDetailCollectionTableItem,
  ShelfTypeItem
} from './BibliographyDetailCollectionTable.vue'

export {
  BibliographyDetailCollectionTable,
  BibliographyDetailCollectionTableItem,
  defaultBibliographyDetailCollectionTableItem,
  ShelfTypeItem
}
